<template>
  <fw-popover
    :position="'top-center'"
    :offset-x="30"
    :offset-y="-21"
    :close-on-click-outside="true"
    :close-on-click-inside-selector="'button'"
    popover-container-class="!shadow-lg !border-0 bg-white"
  >
    <template #trigger>
      <div class="shadow-popover-light flex h-10 items-center justify-center rounded-lg bg-white p-1">
        <fw-button
          :textButton="true"
          size="small"
          :disabled="!isEditorLoaded"
          :class="'hover:bg-transparent-dark-2 flex w-[76px] !justify-end !px-2'"
        >
          <span class="text-sm">{{ parseInt(String(zoomValue)) }}%</span>
          <fw-icon name="chevron-downward" class="ml-1 shrink-0" :width="20" :height="20" />
        </fw-button>
      </div>
    </template>

    <template #content>
      <div
        class="scrollbar-hide font-NeverMind flex max-h-[240px] flex-col gap-1 overflow-y-auto rounded-lg px-3 py-4 ring-1 ring-black ring-opacity-5"
      >
        <button
          v-for="scale in zoomOptions"
          :key="scale"
          class="text-desktop-body-1 text-text-primary hover:bg-transparent-dark-2 flex w-[120px] items-center gap-3 rounded-md px-3 py-2 transition-colors"
          :disabled="!isEditorLoaded"
          @click="updateZoomScale(scale)"
        >
          <span>{{ parseInt(String(scale)) }}%</span>
        </button>

        <div class="bg-grey-300 my-1 h-px shrink-0"></div>

        <button
          class="text-desktop-body-1 text-text-primary hover:bg-transparent-dark-2 flex w-[120px] items-center gap-3 rounded-md px-3 py-2 transition-colors"
          :disabled="!isEditorLoaded"
          @click="fitMap"
        >
          <span>{{ $T('Fit Map') }}</span>
        </button>
      </div>
    </template>
  </fw-popover>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { $T } from 'client/library/translation'
import { useZoomControl } from 'client/pages/app/fragments/shared/editor-bottom-bar/zoom-control'
import { useWorkspaceStore } from 'app/services/pinia/workspace-store'

const isEditorLoaded = computed(() => useWorkspaceStore().editor?.mapStatus === 'loaded')
const { zoomValue, zoomOptions, fitMap, updateZoomScale } = useZoomControl()
</script>

<style scoped>
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
</style>
